import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    attrs: {
      "data-permission": "productGpsrInfoMantenanceList",
      "id": "productGpsrInfoMantenanceList"
    }
  }, [_c('div', {
    staticClass: "status-tabs"
  }, [_c('span', [_vm._v(_vm._s(_vm.t("状态")) + _vm._s(_vm.t("common", "：")))]), _c('a-tabs', {
    attrs: {
      "animated": false,
      "data-permission": "product_compliance_gpsr_search_status",
      "id": "product_compliance_gpsr_search_status"
    },
    on: {
      "change": _vm.handleSearch
    },
    model: {
      value: _vm.searchData.audit_status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "audit_status", $$v);
      },
      expression: "searchData.audit_status"
    }
  }, _vm._l(_vm.GPSrStatusOptins, function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "tab": item.text + "(" + item.total + ")"
      }
    });
  }), 1)], 1), _c('my-enter-search', {
    staticClass: "mb-20",
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "product_compliance_gpsr_search_company",
      "id": "product_compliance_gpsr_search_company"
    },
    model: {
      value: _vm.searchData.code_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_type", $$v);
      },
      expression: "searchData.code_type"
    }
  }, _vm._l(_vm.maintenanceProductFieldEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u53CC\u51FB\u53EF\u6279\u91CF\u67E5\u8BE2"),
      "placeholder": _vm.t('双击可批量查询')
    },
    on: {
      "dblclick": _vm.handleDblClick
    },
    model: {
      value: _vm.code_value_str,
      callback: function ($$v) {
        _vm.code_value_str = $$v;
      },
      expression: "code_value_str"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "product_compliance_gpsr_search_company",
      "id": "product_compliance_gpsr_search_company"
    },
    model: {
      value: _vm.searchData.product_name_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "product_name_type", $$v);
      },
      expression: "searchData.product_name_type"
    }
  }, _vm._l(_vm.productNameLangEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u8BF7\u8F93\u5165"),
      "placeholder": _vm.t('请输入')
    },
    model: {
      value: _vm.searchData.product_name_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "product_name_value", $$v);
      },
      expression: "searchData.product_name_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u54C1\u7C7B"),
      "data-permission": "product_compliance_gpsr_search_category",
      "id": "product_compliance_gpsr_search_category",
      "show-tip": "",
      "placeholder": _vm.t('商品品类'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.category_id,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "category_id", $$v);
      },
      expression: "searchData.category_id"
    }
  }, _vm._l(_vm.productCategoryOptions, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426GPSR\u4EA7\u54C1"),
      "data-permission": "product_compliance_gpsr_search_is_gpsr",
      "id": "product_compliance_gpsr_search_is_gpsr",
      "show-tip": "",
      "placeholder": _vm.t('是否GPSR产品'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.is_gpsr,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "is_gpsr", $$v);
      },
      expression: "searchData.is_gpsr"
    }
  }, _vm._l(_vm.booleanEnumOptions, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5408\u89C4\u8D1F\u8D23\u4EBA\u7C7B\u578B"),
      "data-permission": "product_compliance_gpsr_search_compliance_leader_type",
      "id": "product_compliance_gpsr_search_compliance_leader_type",
      "show-tip": "",
      "placeholder": _vm.t('合规负责人类型'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.compliance_leader_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "compliance_leader_type", $$v);
      },
      expression: "searchData.compliance_leader_type"
    }
  }, _vm._l(_vm.agentNameTypeEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "value": _vm.$enum.product.CompanyNameEnum.COMPANY,
      "data-permission": "product_compliance_gpsr_search_compliance_company",
      "id": "product_compliance_gpsr_search_compliance_company"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": _vm.$enum.product.CompanyNameEnum.COMPANY
    }
  }, [_vm._v(_vm._s(_vm.t("合规负责人名称")))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u652F\u6301\u67E5\u8BE2\u591A\u79CD\u516C\u53F8\u540D\u79F0"),
      "placeholder": _vm.t('支持查询多种公司名称')
    },
    model: {
      value: _vm.searchData.company_and_manufacturer,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "company_and_manufacturer", $$v);
      },
      expression: "searchData.company_and_manufacturer"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "fbu-analyse-name": $t("GPSR\u6807\u7B7E\u6765\u6E90"),
      "data-permission": "product_compliance_gpsr_search_label_source",
      "id": "product_compliance_gpsr_search_label_source",
      "show-tip": "",
      "placeholder": _vm.t('GPSR标签来源'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.label_source,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "label_source", $$v);
      },
      expression: "searchData.label_source"
    }
  }, _vm._l(_vm.labelSourceEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text))]);
  }), 1)], 1), _c('span', {
    staticClass: "ml-20",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-sign": "compliance_gpsr_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t("搜索")) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "compliance_gpsr_search_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t("重置")) + " ")])], 1)], 1), _c('div', {
    staticClass: "flex mb-15"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.t("已选")) + _vm._s(_vm.t("common", ":")) + " " + _vm._s(_vm.multipleSelection.length))]), _c('a-dropdown', {
    staticClass: "ml-10"
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "compliance_gpsr_export_all",
      "id": "compliance_gpsr_export_all",
      "data-sign": "compliance_gpsr_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExportAll();
      }
    }
  }, [_vm._v(_vm._s(_vm.t("导出全部")))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "compliance_gpsr_export_seleted",
      "id": "compliance_gpsr_export_seleted",
      "data-sign": "compliance_gpsr_export_seleted",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExportSelected();
      }
    }
  }, [_vm._v(_vm._s(_vm.t("导出已选")))])], 1), _c('a-button', [_vm._v(" " + _vm._s(_vm.t("导出")) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1)], 1), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm.searchData.audit_status && [_vm.$enum.product.GpsrDataStatusEnum.PASS, _vm.$enum.product.GpsrDataStatusEnum.REJECT].includes(+_vm.searchData.audit_status) ? _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'compliance_gpsr_import_edit',
      expression: "'compliance_gpsr_import_edit'"
    }],
    staticClass: "ml-10",
    attrs: {
      "data-permission": "compliance_gpsr_import_edit",
      "id": "compliance_gpsr_import_edit",
      "data-sign": "compliance_gpsr_import_edit",
      "type": "primary",
      "ghost": "",
      "fbu-analyse-name": $t("\u6279\u91CF\u4FEE\u6539\u5546\u54C1GPSR\u4FE1\u606F")
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'MaintenanceComplianceOfficerBulkUpdatePage'
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.t("批量修改商品GPSR信息")))]) : _vm._e(), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'compliance_gpsr_add',
      expression: "'compliance_gpsr_add'"
    }],
    staticClass: "ml-10",
    attrs: {
      "data-permission": "compliance_gpsr_add",
      "id": "compliance_gpsr_add",
      "data-sign": "compliance_gpsr_add",
      "type": "primary",
      "ghost": "",
      "fbu-analyse-name": $t("\u6279\u91CF\u65B0\u589E\u5546\u54C1GPSR\u4FE1\u606F")
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'MaintenanceComplianceOfficerBulkPage'
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.t("批量新增商品GPSR信息")))]), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'compliance_gpsr_add',
      expression: "'compliance_gpsr_add'"
    }],
    staticClass: "ml-10",
    attrs: {
      "data-permission": "compliance_gpsr_add",
      "id": "compliance_gpsr_add",
      "data-sign": "compliance_gpsr_add",
      "type": "primary",
      "fbu-analyse-name": $t("\u65B0\u589E")
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.t("新增")))])], 1)]), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "fixed-header": "",
      "is-filter-box": "",
      "name": "productGpsrInfoMantenanceList",
      "data-sign": "product_Gpsr_info_mantenance_list",
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "row-key": "id",
      "row-selection": {
        selectedRowKeys: _vm.multipleSelection,
        onChange: _vm.onSelectChange
      },
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "audit_status_text",
      fn: function (ref) {
        var record = ref.record;
        var row = ref.row;
        return _c('div', {}, [_vm._v(" " + _vm._s(record.audit_status_text) + " "), record.audit_status === _vm.$enum.product.MaintenanceProductStatusEnum.REJECT ? _c('a-tooltip', {
          attrs: {
            "placement": "top",
            "overlayClassName": "expandTooltip"
          }
        }, [_c('template', {
          slot: "title"
        }, [_c('div', [_vm._v(_vm._s(record.rejection_remark))])]), _c('a-icon', {
          staticStyle: {
            "line-height": "1",
            "color": "red"
          },
          attrs: {
            "type": "info-circle"
          }
        })], 2) : _vm._e()], 1);
      }
    }, {
      key: "product_sku",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('a', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.product_sku,
            expression: "record.product_sku"
          }],
          on: {
            "click": function () {
              return _vm.$router.push({
                name: 'ProductDetail',
                query: {
                  sku: record.product_sku
                },
                params: {
                  noCache: 1
                }
              });
            }
          }
        }, [_vm._v(" " + _vm._s(record.product_sku) + " ")])]);
      }
    }, {
      key: "company_info",
      fn: function (ref) {
        var record = ref.record;
        var row = ref.row;
        return _c('div', {}, [record.compliance_leader_type !== _vm.$enum.product.COMPLIANCE_NAME_TYPE.MANUFACTURER_NAME ? [_c('div', [_vm._v(_vm._s("" + _vm.complianceLeaderTypeText(row) + _vm.t('公司名称：'))), _c('a', {
          on: {
            "click": function ($event) {
              return _vm.handleComplianceLeaderDetail(record);
            }
          }
        }, [_vm._v(_vm._s(row.company))])]), _c('div', [_vm._v(_vm._s(_vm.complianceLeaderTypeText(row)) + _vm._s(_vm.t('公司地址：')) + _vm._s(_vm._f("filterEmpty")(row.address)))]), _c('div', [_vm._v(_vm._s(_vm.complianceLeaderTypeText(row)) + _vm._s(_vm.t('电话：')) + _vm._s(_vm._f("filterEmpty")(row.phone)))]), _c('div', [_vm._v(_vm._s(_vm.complianceLeaderTypeText(row)) + _vm._s(_vm.t('邮箱：')) + _vm._s(_vm._f("filterEmpty")(row.mail)))])] : [_vm._v("--")]], 2);
      }
    }, {
      key: "manufacturer_info",
      fn: function (ref) {
        var record = ref.record;
        var row = ref.row;
        return _c('div', {}, [record.compliance_leader_type ? [_c('div', [_vm._v(_vm._s(_vm.t('【制造商】公司名称：')) + " "), record.compliance_leader_type === _vm.$enum.product.COMPLIANCE_NAME_TYPE.MANUFACTURER_NAME ? _c('a', {
          on: {
            "click": function ($event) {
              return _vm.handleComplianceLeaderDetail(record);
            }
          }
        }, [_vm._v(_vm._s(_vm._f("filterEmpty")(row.manufacturer_name)))]) : _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(row.manufacturer_name)))])]), _c('div', [_vm._v(_vm._s(_vm.t('【制造商】公司地址：')) + _vm._s(_vm._f("filterEmpty")(row.manufacturer_address)))]), _c('div', [_vm._v(_vm._s(_vm.t('【制造商】电话：')) + _vm._s(_vm._f("filterEmpty")(row.manufacturer_phone)))]), _c('div', [_vm._v(_vm._s(_vm.t('【制造商】邮箱：')) + _vm._s(_vm._f("filterEmpty")(row.manufacturer_email)))])] : [_vm._v("--")]], 2);
      }
    }, {
      key: "time",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('div', [_vm._v(_vm._s(_vm.t("创建时间：")) + _vm._s(_vm._f("filterEmpty")(record.create_time)))]), _c('div', [_vm._v(_vm._s(_vm.t("更新时间：")) + _vm._s(_vm._f("filterEmpty")(record.update_time)))]), _c('div', [_vm._v(_vm._s(_vm.t("审核时间：")) + _vm._s(_vm._f("filterEmpty")(record.audit_time)))]), _c('div', [_vm._v(_vm._s(_vm.t("驳回时间：")) + _vm._s(_vm._f("filterEmpty")(record.rejection_time)))])]);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        var row = ref.row;
        return _c('my-operation', {}, [row.audit_status === _vm.$enum.product.GpsrDataStatusEnum.WAITING_FOR_MAINTENANCE ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'compliance_gpsr_maintain',
            expression: "'compliance_gpsr_maintain'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "compliance_gpsr_maintain",
            "id": "compliance_gpsr_maintain",
            "data-sign": "compliance_gpsr_maintain",
            "fbu-analyse-name": $t("\u7EF4\u62A4")
          },
          on: {
            "click": function ($event) {
              return _vm.handleUpdate(row, 'maintenance_compliance_officer/maintain');
            }
          }
        }, [_vm._v(_vm._s(_vm.t("维护")))]) : _vm._e(), [_vm.$enum.product.GpsrDataStatusEnum.PASS, _vm.$enum.product.GpsrDataStatusEnum.REJECT].includes(row.audit_status) ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'compliance_gpsr_update',
            expression: "'compliance_gpsr_update'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "compliance_gpsr_update",
            "id": "compliance_gpsr_update",
            "data-sign": "compliance_gpsr_update",
            "fbu-analyse-name": $t("\u4FEE\u6539")
          },
          on: {
            "click": function ($event) {
              return _vm.handleUpdate(row, 'maintenance_compliance_officer/update');
            }
          }
        }, [_vm._v(_vm._s(_vm.t("修改")))]) : _vm._e(), [_vm.$enum.product.GpsrDataStatusEnum.PASS].includes(row.audit_status) ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'compliance_gpsr_copy',
            expression: "'compliance_gpsr_copy'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "compliance_gpsr_copy",
            "id": "compliance_gpsr_copy",
            "data-sign": "compliance_gpsr_copy",
            "fbu-analyse-name": $t("\u590D\u5236")
          },
          on: {
            "click": function ($event) {
              return _vm.handleUpdate(row, 'maintenance_compliance_officer/copy');
            }
          }
        }, [_vm._v(_vm._s(_vm.t("复制")))]) : _vm._e(), row.audit_status !== _vm.$enum.product.GpsrDataStatusEnum.WAITING_FOR_MAINTENANCE ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'compliance_gpsr_detail',
            expression: "'compliance_gpsr_detail'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "compliance_gpsr_detail",
            "id": "compliance_gpsr_detail",
            "data-sign": "compliance_gpsr_detail",
            "fbu-analyse-name": $t("\u8BE6\u60C5")
          },
          on: {
            "click": function ($event) {
              return _vm.handleViewDetail(row);
            }
          }
        }, [_vm._v(_vm._s(_vm.t("详情")))]) : _vm._e(), row.audit_status !== _vm.$enum.product.GpsrDataStatusEnum.WAITING_FOR_MAINTENANCE ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'compliance_gpsr_log',
            expression: "'compliance_gpsr_log'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "compliance_gpsr_log",
            "id": "compliance_gpsr_log",
            "data-sign": "compliance_gpsr_log",
            "fbu-analyse-name": $t("\u65E5\u5FD7")
          },
          on: {
            "click": function ($event) {
              return _vm.handleLog(row);
            }
          }
        }, [_vm._v(_vm._s(_vm.t("日志")))]) : _vm._e()]);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "name": "productGpsrInfoMantenanceList",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  }), _c('bulk-search-modal', {
    ref: "bulkSearchModal",
    on: {
      "bulkSearch": _vm.handleBulkFeedback
    }
  }), _c('detail-modal', {
    attrs: {
      "rowData": _vm.rowData,
      "visible": _vm.detailVisible
    },
    on: {
      "update:visible": function ($event) {
        _vm.detailVisible = $event;
      }
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };